import { X } from "lucide-react";
import { In } from "./Shell";

// Final-step modal: client confirms favorites count, adds their name + optional email,
// and any overall note. We surface the extra-edits math one more time so there's no
// surprise on the next email.
export default function SubmitModal({
  favCount,
  includedEdits,
  extraCount,
  extraPrice,
  extraTotal,
  clientName,
  setClientName,
  clientEmail,
  setClientEmail,
  overallMessage,
  setOverallMessage,
  submitting,
  onClose,
  onSubmit,
}) {
  return (
    <div
      className="fixed inset-0 bg-stone-900/80 z-40 flex items-center justify-center p-4"
      onClick={onClose}
      data-testid="submit-modal"
    >
      <div className="bg-white max-w-md w-full p-6" onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between mb-4">
          <h2 className="font-serif text-2xl">Send your selections</h2>
          <button onClick={onClose}><X className="w-4 h-4" /></button>
        </div>
        <div className="space-y-3 text-sm">
          <div className="bg-stone-100 p-3 text-stone-700">
            <div className="font-medium">{favCount} favorited</div>
            {includedEdits > 0 && extraCount > 0 && (
              <div className="text-stone-600 mt-1">
                Includes {includedEdits} complimentary edit{includedEdits > 1 ? "s" : ""}. Extras:{" "}
                <strong>{extraCount} × ${Number(extraPrice).toFixed(2)} = ${extraTotal.toFixed(2)}</strong>
              </div>
            )}
          </div>
          <In label="Your name *" value={clientName} onChange={setClientName} testid="submit-name" />
          <In label="Your email (optional)" value={clientEmail} onChange={setClientEmail} type="email" testid="submit-email" />
          <label className="block">
            <span className="text-xs uppercase tracking-[0.18em] text-stone-500">
              Anything to add for your photographer?
            </span>
            <textarea
              rows={3}
              value={overallMessage}
              onChange={(e) => setOverallMessage(e.target.value)}
              className="mt-1 w-full bg-transparent border border-stone-300 p-2 outline-none focus:border-stone-900 text-sm"
              placeholder="Optional"
              data-testid="submit-message"
            />
          </label>
        </div>
        <div className="mt-5 flex justify-end gap-2">
          <button
            onClick={onClose}
            className="px-4 h-10 text-xs uppercase tracking-[0.22em] border border-stone-300 hover:border-stone-600"
          >
            Cancel
          </button>
          <button
            onClick={onSubmit}
            disabled={submitting}
            className="px-5 h-10 bg-stone-900 text-stone-50 text-xs uppercase tracking-[0.22em] hover:bg-stone-800 disabled:opacity-50"
            data-testid="submit-selections-btn"
          >
            {submitting ? "Sending…" : "Send selections"}
          </button>
        </div>
      </div>
    </div>
  );
}
